import React from 'react'

const getTodayDate = () => {
  const today = new Date();
  
  let dd = today.getDate();
  let mm = today.getMonth()+1; 
  const yyyy = today.getFullYear();

  if(dd<10) {
    dd='0'+dd;
  }

  if(mm<10) {
    mm='0'+mm;
  }

  return `${yyyy}_${mm}_${dd}`
}

const getRandomNumber = (toNumber = 100) => {
  return Math.floor(Math.random() * toNumber) + 1;
}

export const requiredInputBoxes = [
  {
    campaignTitle: 'Campaign source',
    type: 'input',
    label: 'utm_source',
    name: 'utmSource',
    placeholder: 'google, yandex, vk, facebook',
  },
  
  {
    campaignTitle: 'Campaign medium',
    type: 'select',
    label: 'utm_medium',
    name: 'utmMedium',
    placeholder: 'cpc, email, banner, article',
  },
  
  {
    campaignTitle: 'Campaign name',
    type: 'input',
    label: 'utm_campaign',
    name: 'utmCampaign',
    placeholder: 'promo, discount, sale',
  },
];

export const optionalInputBoxes = [
  {
    campaignTitle: 'Campaign content',
    type: 'input',
    label: 'utm_content',
    name: 'utmContent',
    placeholder: 'link, landing page',
  },
  
  {
    campaignTitle: 'Campaign term',
    type: 'input',
    label: 'utm_term',
    name: 'utmTerm',
    placeholder: 'free, -30%, registration',
  },
];

export const popupContent = {
  utmSource: {
    header: 'Campaign source',
    body: 
      <React.Fragment>
        <div className="content-term"><strong>utm_source</strong> — the referrer</div>
        <div className="content-description">
          <div className="paragraph"><strong>What for:</strong><br/>To indicate the referrer (e.g. google, newsletter)</div>
          <div className="paragraph"><strong>Example:</strong>
            <ul>
              <li>utm_source=google – context ad in Google Adwords</li>
              <li>utm_source=facebook — context ad in Facebook</li>
            </ul>
          </div>
        </div>
      </React.Fragment>
  },

  utmMedium: {
    header: 'Campaign medium',
    body: 
      <React.Fragment>
        <div className="content-term"><strong>utm_medium</strong> — marketing medium: (e.g. cpc, banner, email)</div>
        <div className="content-description">
          <div className="paragraph">It is recommended to use standard values in this parameter, e.g., cpc (cost per click) — context ad, display — banner ad, social_cpc — ad in social networks</div>
          <div className="paragraph"><strong>What for:</strong><br/>To define the type of campaign or ad</div>
          <div className="paragraph"><strong>Example:</strong>
            <ul>
              <li>utm_medium=organic — FREE search by search engines</li>
              <li>utm_medium=referral — FREE-click from third-party sites - often used in SEO for refferals link building. Not a search engine</li>
              <li>utm_medium=print — newspapers, magazines, printed telephone directories and billboards all fall within the category of print media</li>
              <li>utm_medium=outdoor — banners &amp; hoardings, flags, wraps and etc.</li>
              <li>utm_medium=cpc — contextual ad with cost per click</li>
              <li>utm_medium=ppc — contextual ad with pay per click</li>
              <li>utm_medium=cpv — other ad with cost per visitor</li>
              <li>utm_medium=cpa — other ad with cost per action</li>
              <li>utm_medium=cpp — other ad with cost per point</li>
              <li>utm_medium=cpm — other ad with cost per mile</li>
              <li>utm_medium=social — social channel</li>
              <li>utm_medium=social_cpc — social ad with cost per click</li>
              <li>utm_medium=email — direct mailing</li>
              <li>utm_medium=article — article in mass-media sites or article post in VK</li>
              <li>utm_medium=display — common medium for ad banners on web sites</li>
              <li>utm_medium=post — post in social networks</li>
              <li>utm_medium=video — video in social networks (youtube)</li>
              <li>utm_medium=affiliate — affiliate network</li>
              <li>utm_medium=banner — ad banner</li>
            </ul>
          </div>
        </div>
      </React.Fragment>


  },

  utmCampaign: {
    header: 'Campaign name',
    body: 
      <React.Fragment>
        <div className="content-term"><strong>utm_campaign</strong> — campaign name</div>
        <div className="content-description">
          <div className="paragraph">This required parameter can be named at will</div>
          <div className="paragraph"><strong>What for:</strong><br/>Allows to know two campaign apart in statistics</div>
          <div className="paragraph"><strong>Example:</strong>
            <ul>
              <li>utm_campaign=furniture_for_home – ad campaign of home furniture</li>
            </ul>
          </div>
        </div>
      </React.Fragment>
  },

  utmContent: {
    header: 'Campaign content',
    body: 
      <React.Fragment>
        <div className="content-term"><strong>utm_content</strong> — additional information that can be tracked if other parameters are similar</div>
        <div className="content-description">
          <div className="paragraph"><strong>What for:</strong><br/>Frequently used as a note for an ad inside a campaign. It can have any name. The most convenient way is to use important parameters of the ad — good or service subcategory, type of ad etc</div>

          <div className="paragraph"><strong>Example:</strong>
            <ul>
              <li>utm_content=zero_block240×60 — Zero Block banner 240 x 60 on Tilda</li>
              <li>utm_content=zero_block_text — Zero Block text advertising</li>
            </ul>
          </div>
        </div>
      </React.Fragment>
  },

  utmTerm: {
    header: 'Campaign term',
    body: 
      <React.Fragment>
        <div className="content-term"><strong>utm_term</strong> — The keyword of which ad displaying starts</div>
        <div className="content-description">
          <div className="paragraph">Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link. It is often used for A/B testing and content-targeted ads.</div>
          <div className="paragraph"><strong>What for:</strong><br/>Allows to know two campaign apart in statistics</div>
        </div>
      </React.Fragment>
  },

  customUrlCode: {
    header: 'Custom alias',
    body: 
      <React.Fragment>
        <div className="content-term"><strong>custom link alias</strong> — optional short link ending alias</div>
        <div className="content-description">
          <div className="paragraph">You can make your link more beautiful with own alias name</div>
        </div>
      </React.Fragment>
  }
}

export const presetsParameters = {
  yourValues: {
    utmSource: '',
    utmSourceDescription: '',
    utmMedium: '',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: '',
    utmContent: '',
    utmContentDescription: '',
    utmTerm: '',
    utmTermDescription: '',
  },

  // paid sources

  googleAdwordsPaid: {
    utmSource: 'google',
    utmSourceDescription: '',
    utmMedium: 'cpc',
    utmMediumDescription: '',
    utmCampaign: '{network}',
    utmCampaignDescription: "Instead of {network} Google Adwords will substitute 'g' (Global search), 's' (Search partner) or 'd' (Display Network)",
    utmContent: '{creative}',
    utmContentDescription: 'Instead of {creative} Google Adwords automatically submits the ad ID',
    utmTerm: '{keyword}',
    utmTermDescription: 'Instead of {keyword} Google Adwords automatically substitutes the keyword',
  },

  facebookPaid: {
    utmSource: 'facebook',
    utmSourceDescription: '',
    utmMedium: 'cpc',
    utmMediumDescription: '',
    utmCampaign: '{{campaign.name}}',
    utmCampaignDescription: '',
    utmContent: '{{adset.name}}',
    utmContentDescription: '',
    utmTerm: '{{ad.name}}',
    utmTermDescription: '',
  },

  yandexDirectPaid: {
    utmSource: 'yandex',
    utmSourceDescription: '',
    utmMedium: 'cpc',
    utmMediumDescription: '',
    utmCampaign: '{campaign_id}',
    utmCampaignDescription: 'Instead of {campaign_id} Yandex.Direct automatically submits the campaign ID',
    utmContent: '{ad_id}_{source}',
    utmContentDescription: 'Instead of {ad_id} Yandex.Direct automatically submits the ad ID',
    utmTerm: '{keyword}',
    utmTermDescription: 'Instead of {keyword} Yandex.Direct automatically substitutes the keyword',
  },

  vkPaid: {
    utmSource: 'vkontakte',
    utmSourceDescription: '',
    utmMedium: 'cpc',
    utmMediumDescription: '',
    utmCampaign: '{campaign_id}',
    utmCampaignDescription: 'Instead of {campaign_id} Vkontakte automatically submits the campaign ID',
    utmContent: '{ad_id}',
    utmContentDescription: 'Instead of {ad_id} Vkontakte automatically submits the ad ID',
    utmTerm: '',
    utmTermDescription: '',
  },

  targetMyComPaid: {
    utmSource: 'mycom',
    utmSourceDescription: '',
    utmMedium: 'cpc',
    utmMediumDescription: '',
    utmCampaign: '{{campaign_id}}',
    utmCampaignDescription: 'Instead of {{campaign_id}} Target My.com automatically submits the campaign ID',
    utmContent: '{{banner_id}}',
    utmContentDescription: 'Instead of {{banner_id}} Target My.com automatically submits the ad ID',
    utmTerm: '{{geo}}_{{gender}}_{{age}}',
    utmTermDescription: 'Instead of {{geo}}_{{gender}}_{{age}} Target My.com automatically substitutes region id by the geo-tree myTarget the user came from, sex and age of the user who clicked the link',
  },

  // paid sources
  
  facebookFree: {
    utmSource: 'facebook',
    utmSourceDescription: '',
    utmMedium: 'social',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: '',
    utmContent: `link_${getRandomNumber(100)}`,
    utmContentDescription: 'link_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },
  
  vkFree: {
    utmSource: 'vk',
    utmSourceDescription: '',
    utmMedium: 'social',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: '',
    utmContent: `link_${getRandomNumber(100)}`,
    utmContentDescription: 'link_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },

  emailFree: {
    utmSource: 'newsletter',
    utmSourceDescription: '',
    utmMedium: 'email',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: 'example.com/my-name => my_name',
    utmContent: `link_${getRandomNumber(100)}`,
    utmContentDescription: 'link_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },

  printedProductFree: {
    utmSource: 'paper',
    utmSourceDescription: '',
    utmMedium: 'print',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: 'example.com/my-name => my_name',
    utmContent: `article_${getRandomNumber(100)}`,
    utmContentDescription: 'link_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },

  twitterFree: {
    utmSource: `twitter`,
    utmSourceDescription: '',
    utmMedium: 'social',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: 'example.com/my-name => my_name',
    utmContent: `link_${getRandomNumber(100)}`,
    utmContentDescription: 'link_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },

  youtubeFree: {
    utmSource: `youtube`,
    utmSourceDescription: '',
    utmMedium: 'video',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: 'example.com/my-name => my_name',
    utmContent: `link_${getRandomNumber(100)}`,
    utmContentDescription: 'link_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },

  linkedinFree: {
    utmSource: `linkedin`,
    utmSourceDescription: '',
    utmMedium: 'social',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: 'example.com/my-name => my_name',
    utmContent: `link_${getRandomNumber(100)}`,
    utmContentDescription: 'link_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },

  instagramFree: {
    utmSource: `instagram`,
    utmSourceDescription: '',
    utmMedium: 'social',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: 'example.com/my-name => my_name',
    utmContent: `link_${getRandomNumber(100)}`,
    utmContentDescription: 'link_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },

  thirdPartySiteFree: {
    utmSource: `third_party_site_${getRandomNumber(100)}`,
    utmSourceDescription: '',
    utmMedium: 'referral',
    utmMediumDescription: '',
    utmCampaign: '',
    utmCampaignDescription: 'example.com/my-name => my_name',
    utmContent: `link_${getRandomNumber(100)}`,
    utmContentDescription: 'article_{random number from 1 to 100}',
    utmTerm: getTodayDate(),
    utmTermDescription: '',
  },

}

export const radioButtonsDefault = [
  {
    value: 'yourValues',
    defaultChecked: true,
    spanText: 'Your values',
  },
]

export const radioButtonsFree = [
  {
    value: 'email',
    defaultChecked: false,
    spanText: 'Email',
  },
  {
    value: 'facebook',
    defaultChecked: false,
    spanText: 'Facebook',
  },
  {
    value: 'vk',
    defaultChecked: false,
    spanText: 'vk',
  },
  {
    value: 'youtube',
    defaultChecked: false,
    spanText: 'Youtube',
  },
  {
    value: 'linkedin',
    defaultChecked: false,
    spanText: 'Linkedin',
  },
  {
    value: 'twitter',
    defaultChecked: false,
    spanText: 'Twitter',
  },
  {
    value: 'instagram',
    defaultChecked: false,
    spanText: 'Instagram',
  },
  {
    value: 'thirdPartySite',
    defaultChecked: false,
    spanText: 'Third Party Site',
  },
  {
    value: 'printedProduct',
    defaultChecked: false,
    spanText: 'Printed Product',
  },
]

export const radioButtonsPaid = [
  {
    value: 'facebook',
    defaultChecked: false,
    spanText: 'Facebook',
  },
  {
    value: 'vk',
    defaultChecked: false,
    spanText: 'vk',
  },
  {
    value: 'googleAdwords',
    defaultChecked: false,
    spanText: 'Google Adwords',
  },
  {
    value: 'yandexDirect',
    defaultChecked: false,
    spanText: 'Yandex.Direct',
  },
  {
    value: 'targetMyCom',
    defaultChecked: false,
    spanText: 'Target My.com',
  },
]

export const utmMediumOptions = [
{ value: 'organic', label: 'organic' },
{ value: 'referral', label: 'referral' },
{ value: 'print', label: 'print' },
{ value: 'outdoor', label: 'outdoor' },
{ value: 'cpc', label: 'cpc' },
{ value: 'ppc', label: 'ppc' },
{ value: 'cpv', label: 'cpv' },
{ value: 'cpa', label: 'cpa' },
{ value: 'cpp', label: 'cpp' },
{ value: 'cpm', label: 'cpm' },
{ value: 'social', label: 'social' },
{ value: 'social_cpc', label: 'social_cpc' },
{ value: 'email', label: 'email' },
{ value: 'article', label: 'article' },
{ value: 'display', label: 'display' },
{ value: 'post', label: 'post' },
{ value: 'video', label: 'video' },
{ value: 'affiliate', label: 'affiliate' },
{ value: 'banner', label: 'banner' },
];

export const user = {
  login: 'YWRtaW4=',
  password: 'dW5pZ2luZVNob3J0ZW5lckFkbWluUGElMjQlMjQ='
}


// WEBPACK FOOTER //
// ./src/modules/constants.js